//
// Copyright © 2024 Hardcore Engineering Inc.
// Copyright © 2026 TraceX SAS.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

import { addStringsLoader, loadMetadata } from '@hcengineering/platform'
import { loadLang } from './lang'
import globalProfile, { globalProfileId } from '@hcengineering/global-profile'

addStringsLoader(globalProfileId, loadLang)

const icons = require('../assets/icons.svg') as string // eslint-disable-line
const ProfileBackground = require('../assets/hero-dark.png') as string // eslint-disable-line
const ProfileBackgroundLight = require('../assets/hero-light.jpg') as string // eslint-disable-line

loadMetadata(globalProfile.icon, {
  Globe: `${icons}#globe`
})

loadMetadata(globalProfile.image, {
  ProfileBackground,
  ProfileBackgroundLight
})
